import React from 'react';
import { useGestureHandlerRef } from '@react-navigation/stack';

import useCheckVersion from '@src/hooks/useCheckVersion';
import useRefreshHome from '@src/hooks/useRefreshHome';
import useRefreshImmigrationHome from '@src/hooks/useRefreshImmigrationHome';
import useRefreshPrimeHome from '@src/hooks/useRefreshPrimeHome';
import useRefreshPrimeStatus from '@src/hooks/useRefreshPrimeStatus';
import useRefreshProfile from '@src/hooks/useRefreshProfile';
import useRefreshTourHome from '@src/hooks/useRefreshTourHome';
import useSplashScreen from '@src/hooks/useSplashScreen';

const Configuration: React.FC<any> = ({ children }) => {
  useRefreshHome();
  useRefreshPrimeHome();
  useRefreshImmigrationHome();
  useRefreshTourHome();
  useRefreshProfile();
  useSplashScreen();
  useRefreshPrimeStatus();
  useCheckVersion();

  return <>{children}</>;
};

export default React.memo(Configuration);
